<template>
  <div class="form-custom frontend-body">
    <v-app>
      <router-view></router-view>
    </v-app>
  </div>
</template>

<style scoped>
@import "../../assets/css/style.css";
</style>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
export default {
  name: "Auth",
  created() {
    
  },
  mounted() {
    if (this.isAuthenticated && this.currentUser && this.currentUser.role === 'producer') {
     
      this.$router.push({
        name: "producer-dashboard",
      });
    } else if(this.isAuthenticated && this.currentUser && this.currentUser.role === 'admin'){
       
      this.$router.push({
        name: "admin-dashboard",
      });
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated", "currentUser"]),
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>